export const HOSTS = {
  dev: 'http://localhost:8080',
  staging: 'https://dashboard-backend-staging-7b0p.onrender.com',
  prod: 'https://api.no-gravity.es',
};
export const HOST = HOSTS[process.env.ENVIRONMENT as keyof typeof HOSTS] ?? HOSTS.dev;

// Publish pipeline sanity ref v20260511 — Safe to remove after verifying Fastlane uploads.
